import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from 'services/auth';

import SignInScene from './sign-in-scene';
import useSignInHooks from './use-sign-in-hooks';

const SignIn = () => {
  const { status } = useAuth();
  const {
    t,
    theme,
    handleOAuthLogin,
    handleSendEmailLink,
    oauthError,
    loginScene,
    handleChangeScene,
    initialValues
  } = useSignInHooks();

  if (status === 'authenticated') {
    return <Redirect to="/orders" />;
  }

  return (
    <SignInScene
      t={t}
      theme={theme}
      handleOAuthLogin={handleOAuthLogin}
      handleSendEmailLink={handleSendEmailLink}
      oauthError={oauthError}
      loginScene={loginScene}
      handleChangeScene={handleChangeScene}
      initialValues={initialValues}
    />
  );
};

export default SignIn;
